import { render, staticRenderFns } from "./file_upload.vue?vue&type=template&id=0bb3949e&scoped=true"
import script from "./file_upload.vue?vue&type=script&lang=js"
export * from "./file_upload.vue?vue&type=script&lang=js"
import style0 from "./file_upload.vue?vue&type=style&index=0&id=0bb3949e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb3949e",
  null
  
)

export default component.exports